import React from "react";
import {withNamespaces} from "react-i18next";
import {Button} from "react-bootstrap";
import {modalActions} from "../../../../actions/modal.actions";
import {connect} from "react-redux";
import {userActions} from "../../../../actions/user.actions";
import UserForm from "../_forms/UserForm";
import {formType} from "../../../../constants/form-type.constants";

const UserActionButton = (
    {
        row,
        t,
        showModal,
        hideModal,
        changePassword,
        activateUser,
        deactivateUser,
        getUserById,
        editUser
    }) => {

    const openModalResetPassword = (row) => {
        showModal({
            open: true,
            title: `${t('reset-password')} ${row.email}`,
            message: `${t('reset-password-msg')} </br> ${t('reset-password-msg2')}`,
            confirmLabel: t('reset-password'),
            confirmIcon: 'fa-key',
            classNameBtnConfirm: 'btn-warning',
            dataId: row.id,
            confirmAction: () => {
                changePassword(row.id);
                hideModal();
            },
            closeModal: closeModal,
        }, 'confirm');
    };

    const openModalActivateUser = (row) => {
        showModal({
            open: true,
            title: `${t('activate')} ${row.email}`,
            message: `${t('activate-msg')}`,
            confirmLabel: t('activate'),
            confirmIcon: 'fa-check-circle',
            classNameBtnConfirm: 'btn-info',
            dataId: row.id,
            confirmAction: () => {
                activateUser(row.id);
                hideModal();
            },
            closeModal: closeModal,
        }, 'confirm')
    };

    const openModalDeactivateUser = (row) => {
        showModal({
            open: true,
            title: `${t('deleting-item')} ${row.email}`,
            message: `${t('delete-msg')}`,
            confirmLabel: t('deactivate'),
            confirmIcon: 'fa-trash',
            classNameBtnConfirm: 'btn-danger',
            confirmAction: () => {
                deactivateUser(row.id);
                hideModal();
            },
            closeModal: closeModal(),
        }, 'confirm')
    };

    const openModalEdit = (row) => {
        getUserById(row.id);
        showModal({
            open: true,
            title: t('edit-user'),
            component: <UserForm data={row} type={formType.EDIT} submit={(data) => onHandleSubmitEdit(data)} />
        }, 'formModal')
    };

    const closeModal = () => {
        hideModal()
    };

    const onHandleSubmitEdit = (data) => {
        editUser(data);
    };

    return (
        <React.Fragment>
            { row.isEnabled === true ? (
                <div>
                    <Button
                        variant={"warning"}
                        className="mx-1"
                        onClick={() => openModalResetPassword(row)}
                    >
                        <i className="fas fa-key" /> &nbsp;
                        {t('reset-password')}
                    </Button>

                    <Button
                        variant={"primary"}
                        className="mx-1"
                        onClick={() => openModalEdit(row)}
                    >
                        <i className="fas fa-edit"/>
                    </Button>

                    <Button
                        variant={"danger"}
                        className="mx-1"
                        onClick={() => openModalDeactivateUser(row)}
                    >
                        <i className="fas fa-trash"/>
                    </Button>
                </div>
            ) : (
                <div>
                    <Button
                        variant={"outline-success"}
                        className="mx-1"
                        onClick={() => openModalActivateUser(row)}
                    >
                        <i className="fas fa-check-circle"/> &nbsp;
                        {t('activate')}
                    </Button>
                </div>
            ) }
        </React.Fragment>
    )
};

const mapDispatchToProps = dispatch => ({
    showModal: (modalProps, modalType) => dispatch(modalActions.showModal({ modalProps, modalType })),
    hideModal: () => dispatch(modalActions.hideModal()),
    changePassword: (userId) => dispatch(userActions.resetPassword(userId)),
    activateUser: (userId) => dispatch(userActions.activateUser(userId)),
    deactivateUser: (userId) => dispatch(userActions.deactivateUser(userId)),
    getUserById: (userId) => dispatch(userActions.getUserById(userId)),
    clearUserById: () => dispatch(userActions.clearUserById()),
    editUser: (editModel) => dispatch(userActions.editUser(editModel))
});
export default withNamespaces()(connect(null, mapDispatchToProps)(UserActionButton));
